module.exports = __webpack_public_path__ + "img/Extra180.c25bf083.png";